import { defaultTheme } from '@cloudquery/theme-app';
import { createTheme as createMuiTheme } from '@mui/material/styles';

import { Link } from './link';

import type {} from '@mui/x-data-grid/themeAugmentation';

export const theme = createMuiTheme(defaultTheme, {
  components: {
    CardActionArea: {
      defaultProps: {
        LinkComponent: Link,
      },
    },
    MuiAlert: {
      styleOverrides: {
        filledSuccess: {
          '.MuiAlert-icon': {
            color: (defaultTheme.palette?.success as any)?.main,
          },
          background:
            'linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), #15B79E',
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: Link,
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        cellCheckbox: {
          paddingLeft: 8,
        },
        columnHeaderCheckbox: {
          width: '58px !important',
        },
        columnHeaderRow: {
          backgroundColor: `${defaultTheme.palette?.background?.paper} !important`,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        sizeSmall: {
          top: '-4px',
        },
      },
    },
    MuiLink: {
      defaultProps: {
        component: Link,
      },
    },
    MuiMenuItem: {
      defaultProps: {
        LinkComponent: Link,
      },
    },
    MuiTab: {
      defaultProps: {
        LinkComponent: Link,
      },
    },
  },
  palette: {
    DataGrid: {
      headerBg: defaultTheme.palette?.background?.paper,
      rowBorderColor: defaultTheme.palette?.divider,
    },
    background: {
      primaryGradient:
        'radial-gradient(448.37% 145.41% at 5.38% 50%, rgba(9, 117, 141, 0.90) 0%, rgba(6, 174, 212, 0.90) 100%)',
      secondaryGradient:
        'radial-gradient(1326.51% 232.98% at -65.82% 15.14%, rgba(7, 103, 83, 0.90) 0%, rgba(23, 178, 100, 0.90) 100%)',
      tertiaryGradient:
        'radial-gradient(1326.51% 232.98% at -65.82% 15.14%, rgba(151, 70, 24, 0.90) 0%, rgba(205, 94, 31, 0.90) 100%)',
    },
    primary: {
      selected: 'rgba(23, 178, 100, 0.12)',
    },
  },
});
